module.exports = __webpack_public_path__ + "img/3d8ad93.png";